import { Location } from "../dtos/location";
import { useEffect, useRef, useState } from "react";
import styles from "./event-location.module.scss";
import baseStyles from "../styles/App.module.scss";
import classNames from "classnames";

function EventLocation(props: { location: Location | undefined | null }) {
  const [size, setSize] = useState({
    width: 0,
    height: 0,
  });
  const locationContainer = useRef<HTMLDivElement>(null);
  let map;

  useEffect(() => {
    if (locationContainer && locationContainer.current) {
      const offsetWidth = locationContainer.current.offsetWidth;
      setSize({
        width: offsetWidth,
        height: Math.round(offsetWidth / 3),
      });
    }
  }, []);

  const getGoogleMapsImageUrl = (): string => {
    const width = Math.round(size.width * 1.5);
    const height = Math.round(size.height * 1.5);
    return `https://maps.googleapis.com/maps/api/staticmap?center=${props.location?.lat},${props.location?.lon}&zoom=14&size=${width}x${height}&markers=color:0x9c27b0|size:tiny|${props.location?.lat},${props.location?.lon}&key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}`;
  };

  const getGoogleMapsAnchorUrl = (): string => {
    return `https://www.google.com/maps/search/?api=1&query=${props.location?.lat},${props.location?.lon}&query_place_id=${props.location?.placeId}`;
  };

  if (props.location?.lon) {
    map = (
      <a
        className={styles.locationLink}
        href={getGoogleMapsAnchorUrl()}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className={styles.locationText}>
          <p className={classNames(baseStyles.centerVer, styles.noMargin)}>
            <span className={"material-icons"}> place </span>
            <b>
              {props.location?.name
                ? props.location?.name
                : props.location?.address}
            </b>
          </p>
          <span className={styles.line}>
            <b>{props.location?.address}</b>
          </span>
        </div>
        <img
          className={styles.locationImg}
          src={getGoogleMapsImageUrl()}
          alt="location_maps"
        />
      </a>
    );
  } else {
    map = (
      <div className={styles.locationText}>
        <p className={classNames(baseStyles.centerVer, styles.noMargin)}>
          <span className="material-icons"> place </span>
          <b>
            {props.location?.name
              ? props.location?.name
              : props.location?.address}
          </b>
        </p>
      </div>
    );
  }

  return (
    <div ref={locationContainer} className={styles.containerEl}>
      {map}
    </div>
  );
}

export default EventLocation;
